module.exports = __webpack_public_path__ + "static/media/body_trace_blood_pressure.5d5daa03.png";